<div
  class="clock"
  [style.position]="'absolute'"
  [style.width.px]="config.width"
  [style.height.px]="config.height"
  [style.left.px]="config.x"
  [style.top.px]="config.y"
  [style.font-size.px]="config.fontSize">
  {{ time$ | async }}
</div>
